import PerformanceFilter from '@/pages/dashboard/pages/performance/components/PerformanceFilter';
import NetworkLatencyService from '@/pages/dashboard/pages/performance/components/NetworkLatencyService';
import PerformanceOverviewService from '@/pages/dashboard/pages/performance/components/PerformanceOverviewService';
import {
  CountryLatencyDistribution,
  NetworkLatencyDistribution,
  NetworkLatencyTrend,
  PerformanceOverview,
} from '@/pages/dashboard/pages/performance/components';

export default {
  PerformanceFilter,
  NetworkLatencyService,
  PerformanceOverviewService,
  PerformanceOverview,
  NetworkLatencyTrend,
  NetworkLatencyDistribution,
  CountryLatencyDistribution,
};
